<template>
  <div class="confirmPanel">
    <!--确认订单弹出框-->
    <el-dialog  
      :visible.sync="confirmPanelShow" 
      width="1000px"  
      center  
      :z-index="11"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"  
      >
      <div class="confirmPanel-title">
          <div>{{orderConfirm?'确认订单':'询价订单'}}</div>
      </div>
      <!--订单信息-->
      <div class="housing">
          <ul class="housing-list">
              <li><p>订单类型:</p><div>{{orderDetail.order_type==1?'住宿订单':'纯会议订单'}}</div></li>
              <li><p>团  号:</p><div>{{orderDetail.title}}</div></li>
              <li v-if="orderDetail.order_type==1"><p>入离日期:</p><div>{{orderDetail.date_in | formatTimestamp(2)}} ~ {{orderDetail.date_out | formatTimestamp(2)}} (共{{Math.abs(orderDetail.date_out - orderDetail.date_in)/86400}}晚)</div></li>
              <li v-if="orderDetail.order_type==1"><p>入住人数:</p><div>{{orderDetail.num}}人</div></li>
              <li v-if="orderDetail.order_type==1&&!orderConfirm"><p>早餐类型:</p><div>{{orderDetail.breakfast }}</div></li>
              <li v-if="orderDetail.eatery"><p>正餐类型:</p><div><span class="mr-1"  v-for="item in starns(orderDetail.eatery,'eateryArr')" :key="item">{{item}}</span></div></li> 
              <li v-if="!orderConfirm&&storeInfo.type==2"><p>星级需求:</p><div><span class="mr-1"  v-for="item in starns(orderDetail.star,'HotelStar')" :key="item">{{item}}</span></div></li>
              <li v-if="orderDetail.other"><p>会议设施:</p><div><span class="mr-1"  v-for="item in starns(orderDetail.other,'meetRoomObj')" :key="item">{{item}}</span></div></li> 
              <li v-if="orderDetail.remark"><p>备注信息:</p><div>{{orderDetail.remark}}</div></li> <!--{{orderDetail.province_name}}省&ensp;{{orderDetail.city_name}}市&ensp;{{orderDetail.district_name}}-->
              <li v-if="!orderConfirm&&storeInfo.type==2"><p>用房区域:</p><div>{{ parseAddress(orderDetail) }}</div></li> <!--{{orderDetail.province_name}}省&ensp;{{orderDetail.city_name}}市&ensp;{{orderDetail.district_name}}-->
          </ul>
      </div>
      <!--用房信息-->
      <OrderHousing :onDehalf="1" :orderDetail="roomList" :modify="modify"></OrderHousing>
      <div  class="confirmPanel-bottoms">
          <!--订单总额-->
          <div class="price" v-if="orderDetail.price>0">
              <div>订单金额：<p>¥{{ orderDetail.price }}</p></div>
          </div>
          <!--修改时订单总额-->
          <div class="price" v-if="modify">
              <div>订单金额：
                <span v-if="price.discount_price">¥{{ price.total_price+ Math.abs(price.discount_price)}}</span>
                <p>¥{{ price.total_price}}</p>
              </div>
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                >
                <div>
                  <ul class="expenseDetails">
                    <li v-if="price.room_price">
                      <p>用房</p>
                      <span>¥{{ price.room_price}}</span>
                    </li>
                    <li v-if="price.meeting_price">
                      <p>会议室</p>
                      <span >¥{{ price.meeting_price}}</span>
                    </li>
                    <li v-if="price.discount_price">
                      <p>优惠房</p>
                      <span class="text-success">¥{{ price.discount_price}}</span>
                    </li>
                    <li v-if="price.add_price">
                      <p>附加需求</p>
                      <span >¥{{ price.add_price}}</span>
                    </li>
                  </ul>
                </div>
                <el-button class="ml-2" size="mini" slot="reference">费用明细</el-button>
              </el-popover>
          </div>
          <el-button  class="bottom" @click="$emit('onShow')">返回修改</el-button>
          <template v-if="storeInfo.type==2">
              <!--确认单按钮-->
              <el-button @click="$emit('placeAnOrder')" :disabled="price.total_price<1" type="primary" class="bottom"  v-if="orderConfirm">{{orderConfirmSend?'确认发布':'确认修改  '}}</el-button>
              <el-button type="primary" class="bottom" @click="$emit('placeAnOrder')"  v-else-if="!modify">确认发布</el-button>
              <el-button @click="$emit('placeAnOrder')" :disabled="price.total_price<1" type="primary" class="bottom"  v-else-if="modify">{{behalf?'确认设置代订收款':'通知酒店'}}</el-button>
          </template>
          <template v-if="storeInfo.type==3">
            <template v-if="orderConfirm">
              <el-button @click="$emit('placeAnOrder')" :disabled="price.total_price<1" type="primary" class="bottom"  v-if="orderConfirm">{{orderConfirmSend?'确认发布':'确认修改  '}}</el-button>
            </template>
            <template v-else>
              <el-button :disabled="price.total_price<1" @click="$emit('placeAnOrder')" type="success" class="bottom" >通知预订人</el-button>
              <el-button :disabled="price.total_price<1" @click="$emit('placeAnOrder',{flag:1})" type="warning" class="bottom">通知支付人</el-button>
            </template>
          </template>
      </div>
      <!--提示-->
      <div class="hint" v-if="price.total_price<1">
        订单总额不可小于1元
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters,mapActions} from 'vuex'
import provinces from '@/assets/utils/provinces'             //省份信息
import OrderHousing from '@/views/Order/OrderDetail/HotelOrder/Components/OrderHousing'
export default {
  name: 'confirmPanel',
  components: {OrderHousing},
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    },
    modify: {
      type: Boolean,
      default: false
    },
    behalf: {
      type: [String, Number]  ,
      default: ''
    },
    confirmPanelShow: {
      type: Boolean,
      default: false
    },
    //是否是确认订单
    orderConfirm: {
      type: Boolean,
      default: false
    },
    //是否是发布确认订单
    orderConfirmSend: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      roomList:{},
      price:{},                       //修改时订单金额      
    };
  },
  computed: {
     ...mapGetters(['storeInfo']),
  },
  watch: {
    orderDetail: {
      async handler(newVal, oldVal) {
        let roomList={
          ...newVal,
          room_need_arr:{
            mode:1,
            list:newVal.room_need_arr?newVal.room_need_arr:newVal.room_need 
          },
          meeting_need_arr:{
            mode:0,
            list:newVal.meeting_need_arr?newVal.meeting_need_arr:newVal.meeting_need
          },
          discount_need_arr:{
            mode:0,
            list:newVal.discount_need_arr?newVal.discount_need_arr:newVal.discount_need 
          },
          add_need_arr:{
            mode:0,
            list:newVal.add_need_arr?newVal.add_need_arr:newVal.add_need 
          },
        };
        roomList=JSON.parse(JSON.stringify(roomList));
        if(this.modify){
          // 需要格式化的key集合
          let data={
            ...newVal,
            add_need:JSON.stringify(newVal.add_need)
          }
          const formatKeys = ['room_need','meeting_need','discount_need','add_need']
          formatKeys.forEach(key => {
            data[key]  = this.formatListJson(newVal[key],key)
          });
          let res=await this.POST_ComputeOrderHotelPrice({orderInfo:JSON.stringify(data)});
          this.price=res;
          
          const isObj = (v) => v !== null && typeof v === 'object'&&v.length!=0;
          let room_need_arr=isObj(roomList.room_need_arr)?roomList.room_need_arr:{list:[],mode:0,num:0,price:0};
          let discount_need_arr=isObj(roomList.discount_need_arr)?roomList.discount_need_arr:{list:[],mode:0,num:0,price:0};
          //用房与优惠房合并
          discount_need_arr.list.forEach(item => {
              const idx = room_need_arr.list.findIndex(v => v.date === item.date)
              const newOfferList = item.offer_info.map(offer => ({
                ...offer,
                disdRoom: true
              }))
              if (idx > -1) {
                room_need_arr.list[idx].offer_info.push(...newOfferList)
              } else {
                room_need_arr.list.push({
                  date: item.date,
                  offer_info: newOfferList
                })
              }
          })
        }
        this.roomList=roomList;
      },
      deep: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_ComputeOrderHotelPrice']),
    // 封装统一序列化方法
    formatListJson(val,type) {
      if(!val)return '';
      // 无数据返回空对象字符串，有数据包裹list序列化
      const arr = val || []
      return JSON.stringify({ mode:type=='meeting_need'||type=='add_need'?0:1,list: arr })
    },
    //星级需求
    starns(e,type){
        let result
        if(!e)return['无']
        if(!e.toString().includes(',')){
          result=new Array(e)
        }else{
          if(!Array.isArray(e)){
            result=e.split(',')
          }
        }
        let n=this.$options.filters['formatStars'](result,type);
        return n
    },
    //获取本地地址信息
    parseAddress(res){
      if(!res.city)return ''
      let city = provinces.find(item => item.id == res.city);
      let province = provinces.find(item => item.id == res.province);
      let district='';
      res.district.split(',').map(rict=>{
        district+= provinces.find(item => item.id == rict).title+'  '
      })
      return `${city.title}省、${province.title}市、${district}`;
    },
  }
};
</script>

<style lang="scss" scoped>
  .confirmPanel-title{
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 12px;
      text-align: center;
      overflow: hidden;

  }
  
  .housing{
      width: 92%;
      padding: 16px 2%;
      background-color: #fff;
      border-radius: 6px;
      border: 1px #eee solid;
      margin: 0 auto;
      margin-top: 20px;
      padding-top:4px;
  }
  .housing-list{
      display: flex;
      flex-wrap: wrap;
      li{
          width: 49%;
          margin-top: 12px;
          p{
              width: 80px;
              color: #999;
              float: left;
          }
          div{
              display: inline-block;
              width: 78%;
          }
      }
  }
  .confirmPanel-bottoms{
      display: flex;
      justify-content: center;
      width: 96%;
      margin: 0 auto;
      margin-top: 24px;
  }
  .price{
      margin-right:auto;
      line-height: 30px;
      color: var(--smtc-color-text-black);
      font-weight: bold;
      display: flex;
      span{
          color: var(--smtc-color-text-shallow);
          text-decoration: line-through;
          margin-right: 6px;
          font-weight: normal;
          font-size: 12px;
      }
      p{
          display: inline-block;
          color: red;
      }
  }
  .hint{
    font-size: 12px;
    text-align: right;
    margin-right: 16px;
    margin-top: 6px;
    color: red;
  }
  .el-icon-question{
    color: var(--smtc-color-primary);
    font-size: 16px;
    margin-left: 6px;
    margin-top: 7px;
  }
  .expenseDetails{
    width: 100%;
    li{
      border-bottom: 1px #eee solid;
      padding: 12px 0;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #333;
    }
    li:last-child{
      border-bottom: none;
    }
  }
</style>
<style>
  .confirmPanel .el-dialog__header{
    padding: 0;
  }
</style>
